<template>
  <v-col cols="12" lg="3" sm="6">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text>
        <div class="text-h6 font-weight-black">Vínculos</div>
      </v-card-text>

      <apexchart v-if="hasData" height="100" :options="chartOptions" :series="series" />

      <div v-else class="d-flex align-center justify-center text-grey" style="height: 100px">
        Sem registros de vínculos
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ProfessorVinculoCard",

  props: {
    franquiaId: {
      default: null,
      type: Number,
    },
  },

  data() {
    return {
      chartOptions: {
        chart: {
          height: 400,
          offsetX: -10,
          type: "donut",
        },

        labels: ["Efetivos", "Celetistas"],

        legend: {
          horizontalAlign: "top",
          offsetY: -5,
          position: "right",
          show: true,
        },

        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                width: 400,
              },

              legend: {
                position: "top",
              },
            },
          },
        ],
      },

      loading: false,

      series: [],
    };
  },

  computed: {
    hasData() {
      return this.series.some((value) => value > 0);
    },
  },

  watch: {
    franquiaId: {
      handler(value) {
        this.getVinculos(value);
      },

      immediate: true,
    },
  },

  methods: {
    async getVinculos(franquiaId) {
      if (!franquiaId) {
        this.series = [];
        return;
      }

      this.loading = true;

      try {
        const response = await this.$services.professoresService.vinculos(franquiaId);

        this.series = [response?.professoresEfetivos, response?.professoresCeletistas].map(
          (value) => Number(value) || 0
        );
      } catch (error) {
        console.error("Erro ao carregar dados de vínculos:", error);
        this.series = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
